import React from 'react';
import styled from 'styled-components/macro';
import scaleSize from 'utils/scale-size';
import WatchListIcon from 'components/Icons/menu-volia/watchlist';

const StyledWarpper = styled.div`
  position: absolute;
  width: ${scaleSize(350)}px;
  height: ${scaleSize(300)}px;
  text-align: center;
  margin: auto;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
`;

const StyledMessage = styled.div`
  font-family: 'RobotoRegular';
  font-style: normal;
  font-weight: 500;
  font-size: ${scaleSize(34)}px;
  line-height: ${scaleSize(40)}px;
  text-align: center;
  letter-spacing: -0.236111px;
  color: #f4f4f4;
  opacity: 0.5;
`;

const NoContentStub = () => {
  return (
    <StyledWarpper>
      <WatchListIcon width={192} height={192} />
      <StyledMessage>You haven't added yet anything</StyledMessage>
    </StyledWarpper>
  );
};

export default NoContentStub;
